import React, { Component } from "react";
import {
  ArrowBack,
  Check,
  Close,
  ExpandMore,
  ExpandLess,
  PlayArrow,
  Menu,
  ArrowBackIos,
  ArrowForwardIos,
  InfoOutlined,
  ArrowDropUp,
  ArrowDropDown,
  Remove,
  Add,
  CloudUpload,
  VideoCallOutlined,
  EditOutlined,
  EventAvailable,
  EmailOutlined,
  HelpOutline,
} from "@material-ui/icons";
import GoogleSlidesImage from "assets/img/icons/google-slides.png";
import CanvaLogoImage from "assets/img/icons/canva.png";
import { ReactComponent as FullScreenImage } from "assets/img/icons/fullscreen.svg";
import { ReactComponent as NextImage } from "assets/img/icons/next-arrow.svg";
import { ReactComponent as PreviousImage } from "assets/img/icons/previous-arrow.svg";
import { ReactComponent as FittingRoomImage } from "assets/img/icons/fitting-room.svg";
import { ReactComponent as LightingImage } from "assets/img/icons/lighting.svg";
import { ReactComponent as HeatingImage } from "assets/img/icons/heating.svg";
import { ReactComponent as WifiImage } from "assets/img/icons/wifi.svg";
import { ReactComponent as AirConditioningImage } from "assets/img/icons/air-conditioning.svg";
import { ReactComponent as ToiletsImage } from "assets/img/icons/toilets.svg";
import { ReactComponent as StockRoomImage } from "assets/img/icons/stock-room.svg";
import { ReactComponent as WheelchairAccessImage } from "assets/img/icons/wheelchair-access.svg";
import { ReactComponent as FAQExpandImage } from "assets/img/icons/faq-expand.svg";
import { ReactComponent as FAQCollapseImage } from "assets/img/icons/faq-collapse.svg";
import { ReactComponent as AreaImage } from "assets/img/icons/area.svg";
import { ReactComponent as FootfallImage } from "assets/img/icons/footfall.svg";
import { ReactComponent as SpendImage } from "assets/img/icons/spend.svg";
import { ReactComponent as CashDeskImage } from "assets/img/icons/cash-desk.svg";
import { ReactComponent as ShelvingImage } from "assets/img/icons/shelving.svg";
import { ReactComponent as SpeakersImage } from "assets/img/icons/speakers.svg";
import { ReactComponent as SecurityImage } from "assets/img/icons/security.svg";
import { ReactComponent as VisaImage } from "assets/img/icons/visa.svg";
import { ReactComponent as MastercardImage } from "assets/img/icons/mastercard.svg";
import { ReactComponent as StaffImage } from "assets/img/icons/staff.svg";
import { ReactComponent as StorageImage } from "assets/img/icons/storage.svg";
import { ReactComponent as FurnitureImage } from "assets/img/icons/furniture.svg";
import { ReactComponent as BookingImage } from "assets/img/icons/booking.svg";
import { ReactComponent as DesignImage } from "assets/img/icons/design.svg";
import { ReactComponent as EditImage } from "assets/img/icons/edit.svg";
import { ReactComponent as InsuranceImage } from "assets/img/icons/insurance.svg";
import { ReactComponent as AssistanceImage } from "assets/img/icons/assistance.svg";
import { ReactComponent as SuccessImage } from "assets/img/icons/success.svg";
import { ReactComponent as LocationImage } from "assets/img/icons/location.svg";
import { ReactComponent as TimeImage } from "assets/img/icons/start-time.svg";
import { ReactComponent as DateImage } from "assets/img/icons/date.svg";
import { ReactComponent as PhotoImage } from "assets/img/icons/photo.svg";
import { ReactComponent as LinkImage } from "assets/img/icons/link.svg";
import { ReactComponent as MoreImage } from "assets/img/icons/more.svg";
import { ReactComponent as WarningImage } from "assets/img/icons/warning.svg";
import { ReactComponent as DeleteImage } from "assets/img/icons/delete.svg";
import { ReactComponent as AttachmentImage } from "assets/img/icons/attachment.svg";
import { ReactComponent as MenuClosedImage } from "assets/img/icons/menu-closed.svg";
import { ReactComponent as VideoCallImage } from "assets/img/icons/shedule-a-call.svg";
import { ReactComponent as MailImage } from "assets/img/icons/message.svg";
import { ReactComponent as PhoneImage } from "assets/img/icons/phone.svg";

import "./index.scss";

export interface IconProps {
  className?: string;
}

export function getIconClassName(props: IconProps, iconClass?: string) {
  return `icon ${iconClass || ""} ${props.className || ""}`;
}

export class ContinueIcon extends Component<IconProps> {
  render() {
    return <NextImage className={getIconClassName(this.props)} />;
  }
}

export class BackIcon extends Component<IconProps> {
  render() {
    return <ArrowBack className={getIconClassName(this.props)} />;
  }
}

export class CheckIcon extends Component<IconProps> {
  render() {
    return <Check className={getIconClassName(this.props)} />;
  }
}

export class InvalidIcon extends Component<IconProps> {
  render() {
    return <Close className={getIconClassName(this.props)} />;
  }
}

export class CloseIcon extends Component<IconProps> {
  render() {
    return <Close className={getIconClassName(this.props)} />;
  }
}

export class DeleteIcon extends Component<IconProps> {
  render() {
    return <DeleteImage className={getIconClassName(this.props)} />;
  }
}

export class AttachmentIcon extends Component<IconProps> {
  render() {
    return <AttachmentImage className={getIconClassName(this.props)} />;
  }
}

export class MenuClosedIcon extends Component<IconProps> {
  render() {
    return <MenuClosedImage className={getIconClassName(this.props)} />;
  }
}

export class GoogleSlidesIcon extends Component<IconProps> {
  render() {
    return (
      <img
        src={GoogleSlidesImage}
        className={getIconClassName(this.props)}
        alt="Google Slides"
      />
    );
  }
}

export class CanvaIcon extends Component<IconProps> {
  render() {
    return (
      <img
        src={CanvaLogoImage}
        className={getIconClassName(this.props)}
        alt="Canva"
      />
    );
  }
}

export class EditIcon extends Component<IconProps> {
  render() {
    return <EditImage className={getIconClassName(this.props)} />;
  }
}

export class EditIconOutlined extends Component<IconProps> {
  render() {
    return <EditOutlined className={getIconClassName(this.props)} />;
  }
}

export class FullScreenIcon extends Component<IconProps> {
  render() {
    return <FullScreenImage className={getIconClassName(this.props)} />;
  }
}

export class ExpandIcon extends Component<IconProps> {
  render() {
    return <ExpandMore className={getIconClassName(this.props)} />;
  }
}

export class CollapseIcon extends Component<IconProps> {
  render() {
    return <ExpandLess className={getIconClassName(this.props)} />;
  }
}

export class PreviousIcon extends Component<IconProps> {
  render() {
    return <PreviousImage className={getIconClassName(this.props)} />;
  }
}

export class NextIcon extends Component<IconProps> {
  render() {
    return <NextImage className={getIconClassName(this.props)} />;
  }
}

export class PreviousChevronIcon extends Component<IconProps> {
  render() {
    return <ArrowBackIos className={getIconClassName(this.props)} />;
  }
}

export class NextChevronIcon extends Component<IconProps> {
  render() {
    return <ArrowForwardIos className={getIconClassName(this.props)} />;
  }
}

export class PlayIcon extends Component<IconProps> {
  render() {
    return <PlayArrow className={getIconClassName(this.props)} />;
  }
}

export class OpenMenuIcon extends Component<IconProps> {
  render() {
    return <Menu className={getIconClassName(this.props)} />;
  }
}

export class CloseMenuIcon extends Component<IconProps> {
  render() {
    return <Close className={getIconClassName(this.props)} />;
  }
}

export class FittingRoomIcon extends Component<IconProps> {
  render() {
    return <FittingRoomImage className={getIconClassName(this.props)} />;
  }
}

export class LightingIcon extends Component<IconProps> {
  render() {
    return <LightingImage className={getIconClassName(this.props)} />;
  }
}

export class HeatingIcon extends Component<IconProps> {
  render() {
    return <HeatingImage className={getIconClassName(this.props)} />;
  }
}

export class WifiIcon extends Component<IconProps> {
  render() {
    return <WifiImage className={getIconClassName(this.props)} />;
  }
}

export class AirConditioningIcon extends Component<IconProps> {
  render() {
    return <AirConditioningImage className={getIconClassName(this.props)} />;
  }
}

export class ToiletsIcon extends Component<IconProps> {
  render() {
    return <ToiletsImage className={getIconClassName(this.props)} />;
  }
}

export class StockRoomIcon extends Component<IconProps> {
  render() {
    return <StockRoomImage className={getIconClassName(this.props)} />;
  }
}

export class WheelchairAccessIcon extends Component<IconProps> {
  render() {
    return <WheelchairAccessImage className={getIconClassName(this.props)} />;
  }
}

export class FAQExpandIcon extends Component<IconProps> {
  render() {
    return <FAQExpandImage className={getIconClassName(this.props)} />;
  }
}

export class FAQCollapseIcon extends Component<IconProps> {
  render() {
    return <FAQCollapseImage className={getIconClassName(this.props)} />;
  }
}

export class InfoIcon extends Component<IconProps> {
  render() {
    return <InfoOutlined className={getIconClassName(this.props)} />;
  }
}

export class ExpandUpIcon extends Component<IconProps> {
  render() {
    return <ArrowDropUp className={getIconClassName(this.props)} />;
  }
}

export class ExpandDownIcon extends Component<IconProps> {
  render() {
    return <ArrowDropDown className={getIconClassName(this.props)} />;
  }
}

export class AreaIcon extends Component<IconProps> {
  render() {
    return <AreaImage className={getIconClassName(this.props)} />;
  }
}

export class FootfallIcon extends Component<IconProps> {
  render() {
    return <FootfallImage className={getIconClassName(this.props)} />;
  }
}

export class SpendIcon extends Component<IconProps> {
  render() {
    return <SpendImage className={getIconClassName(this.props)} />;
  }
}

export class CashDeskIcon extends Component<IconProps> {
  render() {
    return <CashDeskImage className={getIconClassName(this.props)} />;
  }
}

export class ShelvingIcon extends Component<IconProps> {
  render() {
    return <ShelvingImage className={getIconClassName(this.props)} />;
  }
}

export class SpeakersIcon extends Component<IconProps> {
  render() {
    return <SpeakersImage className={getIconClassName(this.props)} />;
  }
}

export class SecurityIcon extends Component<IconProps> {
  render() {
    return <SecurityImage className={getIconClassName(this.props)} />;
  }
}

export class VisaIcon extends Component<IconProps> {
  render() {
    return <VisaImage className={getIconClassName(this.props)} />;
  }
}

export class MastercardIcon extends Component<IconProps> {
  render() {
    return <MastercardImage className={getIconClassName(this.props)} />;
  }
}

export class StaffIcon extends Component<IconProps> {
  render() {
    return <StaffImage className={getIconClassName(this.props)} />;
  }
}

export class StorageIcon extends Component<IconProps> {
  render() {
    return <StorageImage className={getIconClassName(this.props)} />;
  }
}

export class FurnitureIcon extends Component<IconProps> {
  render() {
    return <FurnitureImage className={getIconClassName(this.props)} />;
  }
}

export class AddIcon extends Component<IconProps> {
  render() {
    return <Add className={getIconClassName(this.props)} />;
  }
}

export class RemoveIcon extends Component<IconProps> {
  render() {
    return <Remove className={getIconClassName(this.props)} />;
  }
}

export class BookingIcon extends Component<IconProps> {
  render() {
    return <BookingImage className={getIconClassName(this.props)} />;
  }
}

export class DesignIcon extends Component<IconProps> {
  render() {
    return <DesignImage className={getIconClassName(this.props)} />;
  }
}

export class InsuranceIcon extends Component<IconProps> {
  render() {
    return <InsuranceImage className={getIconClassName(this.props)} />;
  }
}

export class AssistanceIcon extends Component<IconProps> {
  render() {
    return <AssistanceImage className={getIconClassName(this.props)} />;
  }
}

export class WarningIcon extends Component<IconProps> {
  render() {
    return <WarningImage className={getIconClassName(this.props)} />;
  }
}

export class SuccessIcon extends Component<IconProps> {
  render() {
    return <SuccessImage className={getIconClassName(this.props)} />;
  }
}

export class UploadIcon extends Component<IconProps> {
  render() {
    return <CloudUpload className={getIconClassName(this.props)} />;
  }
}

export class LocationIcon extends Component<IconProps> {
  render() {
    return <LocationImage className={getIconClassName(this.props)} />;
  }
}

export class TimeIcon extends Component<IconProps> {
  render() {
    return <TimeImage className={getIconClassName(this.props)} />;
  }
}

export class DateIcon extends Component<IconProps> {
  render() {
    return <DateImage className={getIconClassName(this.props)} />;
  }
}

export class AddVideoIcon extends Component<IconProps> {
  render() {
    return <VideoCallOutlined className={getIconClassName(this.props)} />;
  }
}

export class CheckedItemIcon extends Component<IconProps> {
  render() {
    return (
      <span className={getIconClassName(this.props, "checked-item-icon")}>
        <Check />
      </span>
    );
  }
}

export class UncheckedItemIcon extends Component<IconProps> {
  render() {
    return (
      <span className={getIconClassName(this.props, "unchecked-item-icon")} />
    );
  }
}

export class EventIcon extends Component<IconProps> {
  render() {
    return (
      <EventAvailable className={getIconClassName(this.props, "event-icon")} />
    );
  }
}

export class PhotoIcon extends Component<IconProps> {
  render() {
    return (
      <PhotoImage className={getIconClassName(this.props, "photo-icon")} />
    );
  }
}

export class LinkIcon extends Component<IconProps> {
  render() {
    return <LinkImage className={getIconClassName(this.props, "link-icon")} />;
  }
}

export class EmailIcon extends Component<IconProps> {
  render() {
    return (
      <EmailOutlined className={getIconClassName(this.props, "email-icon")} />
    );
  }
}

export class MoreIcon extends Component<IconProps> {
  render() {
    return <MoreImage className={getIconClassName(this.props, "more-icon")} />;
  }
}

export class HelpIcon extends Component<IconProps> {
  render() {
    return (
      <HelpOutline className={getIconClassName(this.props, "help-icon")} />
    );
  }
}
export class VideoCallIcon extends Component<IconProps> {
  render() {
    return <VideoCallImage className={getIconClassName(this.props)} />;
  }
}
export class MailIcon extends Component<IconProps> {
  render() {
    return <MailImage className={getIconClassName(this.props)} />;
  }
}

export class PhoneIcon extends Component<IconProps> {
  render() {
    return <PhoneImage className={getIconClassName(this.props)} />;
  }
}
